<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
      <MessageDialog
        v-model="popupVisible"
        :title="popupMessage ? popupMessage.title : ''"
        :content="popupMessage ? popupMessage.content : ''"
        :time="popupMessage ? popupMessage.create_time : ''"
        :confirm-text="$t('my.message_confirm') || '我知道了'"
        @confirm="onPopupConfirm"
      />
  </div>
</template>

<script>
import Footer from './common/Footer'
import MessageDialog from './components/MessageDialog.vue'

export default {
  name: 'app',
  components: {
    Footer,
    MessageDialog,
  },
  data() {
    return {
      status: 0,
      popupQueue: [],
      popupMessage: null,
      popupVisible: false,
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if (res && res.code === 200 && res.data) {
          this.$store.commit('setBaseInfoValue', res.data);
        }
      }).catch(() => {})
    },
    getUserInfo(){
      if (!localStorage.getItem('token')) {
        return
      }
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if (res.code === 200) {
          this.$store.commit('setUserInfoValue', res.data);
        }
      })
    },
    checkPopupMessages() {
      if (!localStorage.getItem('token') || this.popupVisible) {
        return;
      }
      this.$http({
        method: 'get',
        url: 'message_popup_list',
      }).then(res => {
        if (res.code === 200 && Array.isArray(res.data) && res.data.length > 0) {
          this.popupQueue = res.data;
          this.showNextPopup();
        }
      }).catch(() => {});
    },
    showNextPopup() {
      if (this.popupQueue.length === 0) {
        this.popupMessage = null;
        this.popupVisible = false;
        return;
      }
      this.popupMessage = this.popupQueue.shift();
      this.popupVisible = true;
    },
    onPopupConfirm() {
      if (!this.popupMessage) {
        return;
      }
      const id = this.popupMessage.id;
      this.$http({
        method: 'post',
        url: 'message_mark_popup',
        data: { id },
      }).finally(() => {
        this.$http({
          method: 'post',
          url: 'message_mark_read',
          data: { id },
        }).finally(() => {
          this.showNextPopup();
        });
      });
    },
  },
  created(){
    this.getBaseInfo();
    this.getUserInfo();
    this.checkPopupMessages();
  },
  watch: {
    '$route'() {
      this.checkPopupMessages();
    },
  },
}
</script>

<style>
html, body, #app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
body {
  font-size: 0.83333rem;
  width: 100%;
  color: #2e0d67;
  background-color: #ffffff;
  -webkit-text-size-adjust: 100%;
}
#app {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  container-type: inline-size;
  container-name: app;
}

@media screen and (min-width: 501px) {
  html {
    background-color: #dfe0e5;
  }
  #app {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
  }
}
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 500px;
  background: linear-gradient(#1d1610, #3b2818) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
